import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { useTranslation } from "react-i18next";

export const ReservationSteps = () => {
  const page = useEngineStore((state) => state.page);
  const { t } = useTranslation();

  switch (page) {
    case AppPage.AccommodationPicking:
      return null;
    case AppPage.ExtraOptions:
      return (
        <div className="reservationStep c-reservation-step u-p0">
          <span className="c-reservation-step__label u-text-dimmed">{t("step")} 1 / 3: </span>
          <p className="c-reservation-step__title">{t("step1")}</p>
        </div>
      );
    case AppPage.HolderAndPaymentInfo:
      return (
        <div className="reservationStep c-reservation-step u-p0">
          <span className="c-reservation-step__label u-text-dimmed">{t("step")} 2 / 3: </span>
          <p className="c-reservation-step__title">{t("step2")}</p>
        </div>
      );
    case AppPage.ReservationOverview:
      return (
        <div className="reservationStep c-reservation-step u-p0">
          <span className="c-reservation-step__label u-text-dimmed">{t("step")} 3 / 3: </span>
          <p className="c-reservation-step__title">{t("step3")}</p>
        </div>
      );
  }
};
